import {
  RESET_DEPARTMENTS,
  GET_DEPARTMENTS,
  SET_DEPARTMENTS,
  CREATE_DEPARTMENTS,
  CREATED_DEPARTMENTS,
  API_ERROR,
  GET_DEPARTMENT,
  SET_DEPARTMENT,
  EDIT_DEPARTMENT,
  EDIT_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT,
} from "./actionTypes";

const initialState = {
  errorDepartment: false,
  loadingDepartment: false,
  dataDepartment: null,
  successDepartment: false,
};

const Department = (state = initialState, action) => {
  switch (action.type) {
    case RESET_DEPARTMENTS:
      state = initialState;
      break;
    case GET_DEPARTMENTS:
      state = {
        errorDepartment: false,
        loadingDepartment: true,
        dataDepartment: null,
      };
      break;
    case SET_DEPARTMENTS:
      state = {
        errorDepartment: false,
        loadingDepartment: false,
        dataDepartment: action.payload,
      };
      break;
    case CREATE_DEPARTMENTS:
      state = {
        errorDepartment: false,
        loadingDepartment: true,
        dataDepartment: action.payload,
        successDepartment: false,
      };
      break;
    case CREATED_DEPARTMENTS:
      state = {
        errorDepartment: false,
        loadingDepartment: false,
        dataDepartment: action.payload,
        successDepartment: true,
      };
      break;
    case GET_DEPARTMENT:
      state = {
        errorDepartment: false,
        loadingDepartment: true,
      };
      break;
    case SET_DEPARTMENT:
      state = {
        errorDepartment: false,
        loadingDepartment: false,
        dataDepartment: action.payload,
      };
      break;
    case EDIT_DEPARTMENT:
      state = {
        errorDepartment: false,
        loadingDepartment: true,
        dataDepartment: action.payload,
        successDepartment: false,
      };
      break;
    case EDIT_DEPARTMENT_SUCCESS:
      state = {
        errorDepartment: false,
        loadingDepartment: false,
        dataDepartment: action.payload,
        successDepartment: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorDepartment: action.payload,
        loadingDepartment: false,
        dataDepartment: null,
        successDepartment: false,
        loadingDeleteDepartment: false,
        successDeleteDepartment: false,
      };
      break;
    case DELETE_DEPARTMENT:
      state = {
        ...state,
        errorDepartment: false,
        loadingDeleteDepartment: true,
        successDeleteDepartment: false,
      };
      break;
    case DELETE_DEPARTMENT_SUCCESS:
      state = {
        ...state,
        errorDepartment: false,
        dataDepartment: action.payload,
        loadingDeleteDepartment: false,
        successDeleteDepartment: true,
      };
      break;
    default:
      //state = { ...state, errorDepartment: false, loadingDepartment: false };
      break;
  }
  return state;
};

export default Department;
